import onReady from '../utils/onReady';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class ScrollToNavigation {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }

    attachClickEvents() {

        for (let i = 0; i < this.dom.nav_links.length; i++) {
            this.dom.nav_links[i].addEventListener("click", (event) => {
                event.preventDefault();
                const href = this.dom.nav_links[i].getAttribute("href").replace("#", "");
                const div_to_scroll_to = document.getElementById(href);
                div_to_scroll_to.scrollIntoView({
                    behavior: 'smooth'
                });
            });
        }

    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container,
            nav_links: container.querySelectorAll(".scroll-link")
        };

        this.attachClickEvents();
    }

}


export default ScrollToNavigation;